import React, { useState } from "react";
import { FormControl, MenuItem, Select } from "@mui/material";
import styles from "./DateFilter.module.scss";
import calender from "../../assets/images/custom-date.svg";
import { DATE_PICKER_VALUE } from "enum/enums";
import CustomButton from "atoms/customButton/CustomButton";
import CalenderModal from "component/calenderModal/CalenderModal";

interface DateFilterProps {
	setDatePickerValue: (a: DATE_PICKER_VALUE) => void;
	datePickerValue: DATE_PICKER_VALUE;
	handleShowModal?: () => void;
	startDate: Date;
	endDate: Date;
	showStartDate: string;
	showEndDate: string;
	disabled?: boolean;
	setEndDate: (a: Date) => void;
	setStartDate: (a: Date) => void;
	fetchAllList: () => void;
}
const DateFilter = ({ setDatePickerValue, datePickerValue, startDate, endDate, disabled, setStartDate, setEndDate, fetchAllList, showStartDate, showEndDate }: DateFilterProps) => {
	const [isOn, setIsOn] = useState(false);
	const handleToggle = () => {
		setIsOn(!isOn); // Invert the boolean state
	};
	
	return (
		<div className={`flex align-center ${styles.dataFilter}`}>
			{
				<FormControl fullWidth>
					<Select
						labelId="demo-simple-select-label"
						id="demo-simple-select"
						disabled={disabled}
						onChange={(e: any) => {
							setDatePickerValue(e.target.value);
						}}
						value={datePickerValue !== DATE_PICKER_VALUE.CUSTOM ? datePickerValue : `${showStartDate}-${showEndDate}`}
					>
						<MenuItem className="hidden" value={`${showStartDate}-${showEndDate}`}>
							{showStartDate} - {showEndDate}
						</MenuItem>

						<MenuItem value={DATE_PICKER_VALUE.SEVEN_DAYS}>Last 7 days</MenuItem>
						<MenuItem value={DATE_PICKER_VALUE.FOURTEEN_DAYS}>Last 14 days</MenuItem>
						<MenuItem value={DATE_PICKER_VALUE.THIRTY_DAYS}>Last 30 Days</MenuItem>
						<MenuItem value={DATE_PICKER_VALUE.THIS_MONTH}>This Month</MenuItem>
						<MenuItem value={DATE_PICKER_VALUE.THIS_QUATER}>This Quater</MenuItem>
					</Select>
				</FormControl>
			}{" "}
			{/* condition for datePickerValue === DATE_PICKER_VALUE.CUSTOM */}
			<div className="custom-date-dialog-main">
				<CustomButton buttonImg={calender} className={`button ${datePickerValue === DATE_PICKER_VALUE.CUSTOM && `active`}`} buttonText="Custom" handleFunc={handleToggle}></CustomButton>
				{isOn && (
					<div className="custom-dialog custom-date-dialog">
						<div className="MuiPaper-root ">
							<CalenderModal
								startDate={startDate}
								setStartDate={setStartDate}
								endDate={endDate}
								setEndDate={setEndDate}
								handleShowModal={handleToggle}
								setDatePickerValue={setDatePickerValue}
								fetchAllList={() => {
									
									fetchAllList();
								}}
							/>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default DateFilter;
